import { g } from '@hcie/core';
import { EventBus } from '@hcie/shared';

function getElements() {
    const container = document.getElementById('canvasScrollArea') as HTMLElement | null;
    const wrapper = document.getElementById('canvasWrapper') as HTMLElement | null;
    const canvas = document.getElementById('drawingCanvas') as HTMLCanvasElement | null;
    return { container, wrapper, canvas };
}

function applyCssZoom(zoom: number) {
    const { wrapper, canvas } = getElements();
    if (!wrapper || !canvas) return;

    // Keep canvas backing store in document pixels; use CSS sizing for zoom.
    wrapper.style.width = `${Math.round(g.image_width * zoom)}px`;
    wrapper.style.height = `${Math.round(g.image_height * zoom)}px`;
    canvas.style.width = `${Math.round(g.image_width * zoom)}px`;
    canvas.style.height = `${Math.round(g.image_height * zoom)}px`;
}

function clampZoom(z: number) {
    return Math.max(0.05, Math.min(z, 32));
}

export function applyZoom(oldZoom: number, e: MouseEvent | null) {
    const { container } = getElements();
    const newZoom = clampZoom(g.zoom || 1);

    if (!container) {
        applyCssZoom(newZoom);
        EventBus.emit('RENDER_LAYERS');
        window.dispatchEvent(new Event('zoomChanged'));
        return;
    }

    // Preserve the viewport focus point (mouse position if provided, else center).
    const rect = container.getBoundingClientRect();
    const focusClientX = e ? e.clientX : rect.left + rect.width / 2;
    const focusClientY = e ? e.clientY : rect.top + rect.height / 2;

    const focusX = (focusClientX - rect.left) + container.scrollLeft;
    const focusY = (focusClientY - rect.top) + container.scrollTop;

    const scale = oldZoom ? (newZoom / oldZoom) : 1;

    applyCssZoom(newZoom);

    container.scrollLeft = (focusX * scale) - (focusClientX - rect.left);
    container.scrollTop = (focusY * scale) - (focusClientY - rect.top);

    EventBus.emit('RENDER_LAYERS');
    window.dispatchEvent(new Event('zoomChanged'));
}

export function zoomIn(e: MouseEvent | null) {
    const oldZoom = g.zoom || 1;
    g.zoom = clampZoom(oldZoom * 1.1);
    applyZoom(oldZoom, e);
}

export function zoomOut(e: MouseEvent | null) {
    const oldZoom = g.zoom || 1;
    g.zoom = clampZoom(oldZoom / 1.1);
    applyZoom(oldZoom, e);
}

